import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare const $: any;

@Component({
	selector: 'app-report-text-form',
	templateUrl: './report-text-form.component.html',
	styleUrl: './report-text-form.component.css'
})
export class ReportTextFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Input() scale: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	scaleList: any = [];
	operatorList = [
		{ id: "==", name: "==" },
		{ id: ">", name: ">" },
		{ id: "<", name: "<" },
		{ id: ">=", name: ">=" },
		{ id: "<=", name: "<=" },
		{ id: "!=", name: "!=" },
		{ id: "-", name: "-" },
	];
	profile_list: any = [];
	decodedId: any = null;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			range: [null],
			operator: [null],
			value: [null, [Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
			text: [null, [Validators.required]],
			scale_id: [null, [Validators.required]],
			profile_id: [null, [Validators.required]],
		});
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		this.getProfileList();
		this.getScaleList();
		if (this.scale) {
			this.f.scale_id.setValue(this.scale);
		}
		if (this.uId) {
			this.getDetails();
		}
	}

	getProfileList() {
		this.apiService.getProfileList().subscribe({
			next: (data) => {
				this.profile_list = data;
			}, error: (error) => {
				this.profile_list = [];
			}
		});
	}

	getScaleList() {
		this.apiService.getAllScaleList().subscribe({
			next: (data: any) => {
				this.scaleList = data;
			}, error: (error) => {
				this.scaleList = [];
			}
		});
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getReportTextDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.decodedId = data.id;
				this.f.range.setValue(data.range);
				this.f.operator.setValue(data.operator);
				this.f.value.setValue(data.value);
				this.f.text.setValue(data.text);
				this.f.scale_id.setValue(data.scale_id);
				this.f.profile_id.setValue(data.profile_id);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload = {
			"range": this.f.range.value === "" ? null : this.f.range.value,
			"operator": this.f.operator.value,
			"value": this.f.value.value === "" ? null : this.f.value.value,
			"text": this.f.text.value,
			"scale_id": this.f.scale_id.value,
			"profile_id": this.f.profile_id.value,
			/* "id": this.uId */
			"id": this.decodedId
		}
		this.showLoader = true;
		this.apiService.createUpdateReportText(payload).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Record with range <strong>' + this.f.range.value + '</strong> already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreReportText(error.error.encryptid).subscribe({
								next: (data: any) => {
									this.toastr.success("Restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.created.emit(data);
									this.clearForm();
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						}
					})
				} else {
					let errorMsg = "Something went wrong.";
					if (error.status == 400) {
						errorMsg = error.error;
						if (typeof errorMsg == 'object') {
							for (const [key, value] of Object.entries(errorMsg)) {
								let val: any = value;
								if (val[0] == "This field must be unique.") {
									val[0] = "Already exists";
								}
								if (this.moduleForm.controls[key]) {
									this.moduleForm.controls[key].setErrors({ incorrect: true });
									this.customError[key] = val[0];
									let selector = "#" + key;
									try {
										$('html, body').animate({
											scrollTop: $(selector).offset().top - 60 + 'px'
										}, 'fast');
									} catch (error) { }
									$(selector).focus();
								} else {
									this.toastr.error(key + ":" + val[0], 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							}
							return;
						} else {
							this.moduleForm.controls["range"].setErrors({ incorrect: true });
							this.customError["range"] = "Record already exists";
							return;
						}
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true,
					});
				}
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
